import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
  UncontrolledAlert,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { AppDispatch } from "src";
import { useDispatch, useSelector } from "react-redux";
import { addUnit } from "src/slices/thunks";
import { createSelector } from "reselect";
import useToast from "src/components/Common/toast";

const NormalValidation = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { show, ToastComponent } = useToast();
  const units = useSelector((state: any) => state.units.units);
  const unitsTypes = useSelector((state: any) => state.unitsTypes.units);
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      parent: "",
      tipo: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor, insira o nome completo"),
      parent: Yup.string().optional(),
      tipo: Yup.number().required("Por favor, insira o tipo"),
    }),
    onSubmit: async values => {
      await dispatch(addUnit(values)).then(response => {
        if (
          typeof response.payload === "string" &&
          response.payload.includes("Request failed with")
        ) {
          show("Erro", "Erro ao criar orgão de estrutura");
        } else {
          show("Sucesso", "Orgão de estrutura criado com sucesso");
          validation.resetForm();
        }
      });
    },
  });

  return (
    <React.Fragment>
      {ToastComponent}
      <Col>
        <Card>
          <CardBody>
            <Form
              className="needs-validation"
              onSubmit={e => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom01">Nome</Label>
                  <Input
                    name="name"
                    placeholder="Nome"
                    type="text"
                    className="form-control"
                    id="validationCustom01"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom03">Superior</Label>
                  <Input
                    name="parent"
                    placeholder="Superior"
                    type="select"
                    className="form-control"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.parent || ""}
                    invalid={
                      validation.touched.parent && validation.errors.parent
                        ? true
                        : false
                    }
                  >
                    <option value="">Selecione</option>
                    {units.map((unit: any) => (
                      <option value={unit.id} key={unit.id}>
                        {unit.name}
                      </option>
                    ))}
                  </Input>
                  {validation.touched.parent && validation.errors.parent ? (
                    <FormFeedback type="invalid">
                      {validation.errors.parent}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom04">Tipo</Label>
                  <Input
                    name="tipo"
                    placeholder="Função"
                    type="select"
                    className="form-control"
                    id="validationCustom04"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.tipo || ""}
                    invalid={
                      validation.touched.tipo && validation.errors.tipo
                        ? true
                        : false
                    }
                  >
                    <option value="">Selecione</option>
                    {unitsTypes.map((unitType: any) => (
                      <option value={unitType.id} key={unitType.id}>
                        {unitType.name}
                      </option>
                    ))}
                  </Input>
                  {validation.touched.tipo && validation.errors.tipo ? (
                    <FormFeedback type="invalid">
                      {validation.errors.tipo}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Button color="primary" type="submit">Salvar</Button>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default NormalValidation;
